import * as React from "react";
import { useState } from "react";
import styled from "styled-components";
import { MenuItem, Input } from "components/bootstrap";
import { Row, Col } from "common/components/layout-styles";
const ColContainer = styled(Col)`
  max-height: 40vh;
  overflow: auto;
`;
const InputRow = styled(Row)`
  margin: ${({ theme }) => theme.spacings.sm} 0;

  & > .form-group {
    margin: 0;
  }
`;
const sortFilterValues = (filter, filterOptions, activeTagFilters) => {
  const sortedFiltersValues = filterOptions.sort((a, b) => {
    if (a.title.toUpperCase() < b.title.toUpperCase()) return -1;
    if (a.title.toUpperCase() > b.title.toUpperCase()) return 1;
    return 0;
  });
  return filter ? sortedFiltersValues : sortedFiltersValues.filter(
    (fOption) => !(activeTagFilters == null ? void 0 : activeTagFilters.find((aOption) => aOption.value === fOption.value))
  );
};
function TagsFilterComponent({ attribute, filter, onSubmit, allActiveFilters }) {
  const { filter_options } = attribute;
  const { tags: activeTagFilters } = allActiveFilters.toJS();
  const [filterOptions, setFilterOptions] = useState(
    sortFilterValues(filter, filter_options, activeTagFilters)
  );
  const [debounceSearchTag, setDebounceSearchTag] = useState(null);
  const onChange = (e) => {
    const allValues = sortFilterValues(filter, filter_options, activeTagFilters);
    if (debounceSearchTag) clearTimeout(debounceSearchTag);
    setDebounceSearchTag(
      setTimeout(() => {
        const { value } = e.target;
        const filteredOptions = allValues.filter(
          (aFilter) => !!aFilter.title.toUpperCase().match(value.toUpperCase())
        );
        setFilterOptions(filteredOptions);
      }, 400)
    );
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(InputRow, { $width: "100%" }, /* @__PURE__ */ React.createElement(Input, { type: "text", placeholder: "Search for a tag", onChange })), /* @__PURE__ */ React.createElement(ColContainer, null, filterOptions.map((fOption) => /* @__PURE__ */ React.createElement(MenuItem, { key: fOption.value, onClick: () => onSubmit(fOption), disabled: (filter == null ? void 0 : filter.value) === fOption.value }, fOption.title))));
}
export default TagsFilterComponent;
